import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { appRoutes } from "./routes";
import { registerSW } from "virtual:pwa-register";
import "./tailwind.css";

import "../excalidraw-app/sentry";
import { AuthProvider } from "./hooks/useAuth";
// import AuthVerify from "./pages/auth/verify";
import { SidePeekProvider } from "./hooks/useSidePeek";
window.__EXCALIDRAW_SHA__ = import.meta.env.VITE_APP_GIT_SHA;
const rootElement = document.getElementById("root")!;
const root = createRoot(rootElement);
registerSW();

// Route table lives in routes.tsx (unit-tested); unknown paths render the
// branded 404 via its `*` splat, and every route carries a branded errorElement.
const router = createBrowserRouter(appRoutes);

root.render(
  <StrictMode>
    <AuthProvider>
      <SidePeekProvider>
        <RouterProvider router={router}></RouterProvider>
      </SidePeekProvider>
    </AuthProvider>
  </StrictMode>,
);
